import recherche from "../assets/recherche.jpeg";
import dis from "../assets/dis.jpeg";
import planification from "../assets/plan.jpeg";
import analyse from "../assets/analyse.jpeg";



const serviceCards = [
    {
        number: "01",
        title: "Expertise et analyse de marché",
        description: "VOLTAUTO transforme les idées en solutions d'ingénierie grâce à une expertise et une analyse des données du marché.",
        image: recherche
    },
    {
        number: "02",
        title: "Conception innovante",
        description: "Grâce à des matériaux avancés et des technologies de pointe, nous créons des concepts qui redéfinissent les standards de l'industrie.",
        image: dis
    },
    {
        number: "03",
        title: "Gestion et exécution de projets",
        description: "Notre expertise en développement produit nous permet de réaliser des projets complexes, intégrés et adaptés aux besoins modernes.",
        image: planification
    },
    {
        number: "04",
        title: "Stratégie et planification avancées",
        description: `• Définition des objectifs\n• Gestion de projets\n• Approche durable\n• Standards industriels\n• Conformité réglementaire\n• Optimisation des coûts`,
        image: analyse
    }
];



export default serviceCards;